/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import { metadataChipSx } from './metadataChipSx';

const TipoServicoChips = ({ item }) => {
  if (!item) return null;

  const tipo = item.tipoServicoNome ?? item.tipoServico;
  const subtipo = item.subtipoNome ?? item.subTipoServico;

  if (!tipo && !subtipo) return null;

  return (
    <>
      {tipo && (
        <Chip
          label={tipo}
          size="small"
          variant="outlined"
          sx={metadataChipSx}
          aria-label={tipo}
        />
      )}
      {subtipo && (
        <Chip
          label={subtipo}
          size="small"
          variant="outlined"
          sx={metadataChipSx}
          aria-label={subtipo}
        />
      )}
    </>
  );
};

TipoServicoChips.propTypes = {
  item: PropTypes.shape({
    tipoServico: PropTypes.string,
    tipoServicoNome: PropTypes.string,
    subTipoServico: PropTypes.string,
    subtipoNome: PropTypes.string,
  }),
};

TipoServicoChips.defaultProps = {
  item: null,
};

export default TipoServicoChips;
